module.exports = __webpack_public_path__ + "img/icon_phone_white.9b8d927.svg";